import React from 'react'
import CheckoutService from "../Integration/CheckoutService";
import Header from '../Integration/Header'; 
import FooterMenu from '../Integration/FooterMenu';

export default function PageCheckout_service() {
 


  return (



    <div>

    <Header/>
    <>
        <CheckoutService/>
     </>
    <FooterMenu/>
    </div>
  )
}
